module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Tasks")]), _vm._v(" "), _c('ul', {
    staticClass: "timeline"
  }, [_c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-green"
  }, [_vm._v(_vm._s(_vm.today))])]), _vm._v(" "), _vm._l((_vm.timeline), function(line) {
    return _c('li', [_c('i', {
      class: 'fa ' + line.icon + ' bg-' + line.color
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-item"
    }, [_c('span', {
      staticClass: "time"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(line.time))]), _vm._v(" "), _c('h3', {
      staticClass: "timeline-header"
    }, [_vm._v(_vm._s(line.title))]), _vm._v(" "), (line.body) ? _c('div', {
      staticClass: "timeline-body",
      domProps: {
        "innerHTML": _vm._s(line.body)
      }
    }) : _vm._e(), _vm._v(" "), (line.buttons) ? _c('div', {
      staticClass: "timeline-footer"
    }, _vm._l((line.buttons), function(btn) {
      return _c('a', {
        class: 'btn btn-' + btn.type + ' btn-xs',
        attrs: {
          "href": btn.href,
          "target": btn.target
        }
      }, [_vm._v(_vm._s(btn.message))])
    })) : _vm._e()])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b6d236"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Tasks.vue
// module id = 1543
// module chunks = 1